export default {
  _30secRetry: 300, // 300 retries = 30 sec
  retryIntervalMs: 100,
  retryErrorMessage: 'Could not find angular app'
}
